import React from 'react';
import { BUSINESS_TYPE } from 'Routes/sign-in/components/LeftSide/constants';
import IntlMessages from 'Util/IntlMessages';

const BusinessTypeTab = ({ businessType, onChangeBusinessType }) => {
  return (
    <div className="business-type-tab">
      <div
        onClick={() => onChangeBusinessType(BUSINESS_TYPE.INDIVIDUAL)}
        className={`business-type-tab-item ${businessType === BUSINESS_TYPE.INDIVIDUAL ? 'business-type-tab-item-active' : ''} cursor-pointer no-drag`}
      >
        <IntlMessages id="signIn.join.company" />
      </div>
      <div
        onClick={() => onChangeBusinessType(BUSINESS_TYPE.FREELANCER)}
        className={`business-type-tab-item ${businessType === BUSINESS_TYPE.FREELANCER ? 'business-type-tab-item-active' : ''} cursor-pointer no-drag`}
      >
        <IntlMessages id="signIn.join.personal" />
      </div>
    </div>
  );
};

export default BusinessTypeTab;
